/* Noirarchy Coven signup (window.Noir.coven). Deferred and global; loads after noir-ui.js.

   Every Coven signup (snippets/noir-coven-form.liquid) is a Shopify customer form.

   Sending without leaving the page: a submit is stopped and the form's own FormData
   (form_type=customer, contact[email], contact[tags]=coven), encoded as the browser would
   post it, is POSTed to the form's action (/contact) with fetch. The button is disabled and shows the sending label ("Sealing...")
   in the same space. Shopify answers by redirecting to the page with the result printed
   in the form; this script reads the sent form's state from that HTML:
     success  the form switches to its success state in place (both states share one grid
              cell, so nothing moves) and the success title takes focus;
     error    Shopify's message (for example an invalid email) shows under the field in
              oxblood, and the button comes back;
     a bot challenge (the response URL contains /challenge), or an answer this script
              cannot read: the form is submitted the normal way, so the challenge can run
              and the page reloads with the result (below).
   An email the browser already knows is not valid shows the "invalid" message the same
   way, without a request (the forms are novalidate while this script runs).
   Shopify's bot protection: the post carries the hCaptcha token (see captcha() below).

   After a reload (no JavaScript, or a challenge) Shopify prints the result (success or
   errors) in EVERY customer form on the page. This script keeps the result only in the
   form that was sent and puts every other form back to its ask state.

   Which form was sent, in order:
     1. the URL hash (each form's action ends in #<form id>, and the browser keeps it
        through Shopify's redirect),
     2. the id stored on submit in sessionStorage 'noir-coven-sent' (cleared once used,
        ignored after an hour),
     3. else the first inline form (not the pop-up) that printed a result.
   When the hash names some other customer form on the page, no Coven form keeps a result.

   After a confirmed success, either way: localStorage 'noir-coven-joined' = '1' (the pop-up
   never opens by itself again in this browser), and the event 'noir:coven:joined' bubbles
   from the form root to document (detail { id, placement }).
   An inline form (envelope or card) is scrolled into view when it is off screen (no
   smooth scroll under reduced motion) and its success title takes focus. An error state
   focuses the email field. The pop-up is left closed: noir-popup.js opens it in its
   success state by reading the API below.

   API (routing runs as soon as the DOM is parsed, so later deferred scripts can read it):
     Noir.coven.joined()     true once any Coven signup succeeded in this browser
     Noir.coven.sentId()     id of the form sent before this page load, else the id stored
                             for a post still in flight (for example on a challenge page), else null
     Noir.coven.state()      'success' | 'error' | null, for the sent form on this page load
     Noir.coven.placement()  'envelope' | 'card' | 'popup' | 'footer' | null, for the sent form
     Noir.coven.ready()      true once routing has run
   Event 'noir:coven:ready' on document after routing, detail { id, state, placement }.
   Storage access is wrapped in try/catch (private windows and blocked storage throw). */
(function () {
  'use strict';

  var Noir = (window.Noir = window.Noir || {});
  if (Noir.coven && Noir.coven.__ready) return;

  var SENT = 'noir-coven-sent';
  var SENT_AT = 'noir-coven-sent-at';
  var JOINED = 'noir-coven-joined';
  var MAX_AGE = 60 * 60 * 1000;

  /* ---------- Storage ---------- */
  function area(session) {
    try {
      return session ? window.sessionStorage : window.localStorage;
    } catch (e) {
      return null;
    }
  }
  function read(key, session) {
    try {
      var s = area(session);
      return s ? s.getItem(key) : null;
    } catch (e) {
      return null;
    }
  }
  function write(key, value, session) {
    try {
      var s = area(session);
      if (s) s.setItem(key, String(value));
    } catch (e) {}
  }
  function erase(key, session) {
    try {
      var s = area(session);
      if (s) s.removeItem(key);
    } catch (e) {}
  }

  function storedId() {
    var id = read(SENT, true);
    if (!id) return null;
    var at = parseInt(read(SENT_AT, true), 10);
    if (at && Date.now() - at > MAX_AGE) {
      clearStored();
      return null;
    }
    return id;
  }
  function clearStored() {
    erase(SENT, true);
    erase(SENT_AT, true);
  }

  /* ---------- Helpers ---------- */
  function reduceMotion() {
    if (typeof Noir.reduceMotion === 'function') return Noir.reduceMotion();
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function emit(el, name, detail) {
    var event;
    try {
      event = new CustomEvent(name, { bubbles: true, detail: detail || {} });
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, true, false, detail || {});
    }
    el.dispatchEvent(event);
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  }

  function idOf(root) {
    return root.getAttribute('data-noir-coven') || '';
  }
  function stateOf(root) {
    return root.getAttribute('data-state') || 'ask';
  }
  function placementOf(root) {
    return root.getAttribute('data-noir-coven-placement') || '';
  }

  /* The root is the form itself or the [data-noir-coven] element inside it. */
  function rootOfForm(form) {
    if (!form || form.tagName !== 'FORM') return null;
    if (form.hasAttribute('data-noir-coven')) return form;
    return form.querySelector('[data-noir-coven]');
  }

  function currentHash() {
    var raw = (window.location.hash || '').replace(/^#/, '');
    try {
      return decodeURIComponent(raw);
    } catch (e) {
      return raw;
    }
  }

  /* ---------- Errors under the field ---------- */
  function describedBy(input, id, on) {
    var ids = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (x) {
      return x && x !== id;
    });
    if (on) ids.push(id);
    if (ids.length) input.setAttribute('aria-describedby', ids.join(' '));
    else input.removeAttribute('aria-describedby');
  }

  function clearError(root) {
    var error = root.querySelector('[data-noir-coven-error]');
    var input = root.querySelector('input[type="email"]');
    if (error) {
      error.textContent = '';
      error.hidden = true;
    }
    if (input) {
      input.removeAttribute('aria-invalid');
      if (error && error.id) describedBy(input, error.id, false);
    }
  }

  function showError(root, text) {
    var error = root.querySelector('[data-noir-coven-error]');
    var input = root.querySelector('input[type="email"]');
    root.setAttribute('data-state', 'error');
    if (error) {
      error.textContent = text;
      error.hidden = false;
    }
    if (input) {
      input.setAttribute('aria-invalid', 'true');
      if (error && error.id) describedBy(input, error.id, true);
      focusEl(input);
    }
  }

  /* ---------- Revert a form that printed someone else's result ---------- */
  function revert(root) {
    clearError(root);
    root.setAttribute('data-state', 'ask');
    var input = root.querySelector('input[type="email"]');
    if (input) input.value = '';
  }

  /* ---------- Send without leaving the page ---------- */
  var canFetch =
    typeof window.fetch === 'function' &&
    typeof window.FormData === 'function' &&
    typeof window.URLSearchParams === 'function' &&
    typeof window.DOMParser === 'function';
  var nativeSubmit = HTMLFormElement.prototype.submit;

  function remember(id) {
    write(SENT, id, true);
    write(SENT_AT, Date.now(), true);
  }

  function setSending(root, on) {
    var button = root.querySelector('.noir-coven__submit');
    if (on) root.classList.add('is-sending');
    else root.classList.remove('is-sending');
    if (button) button.disabled = on;
    root.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function joinedHere(root) {
    clearError(root);
    root.setAttribute('data-state', 'success');
    result = { id: idOf(root), state: 'success', placement: placementOf(root) || null };
    write(JOINED, '1');
    focusEl(root.querySelector('[data-noir-coven-focus]'));
    emit(root, 'noir:coven:joined', { id: result.id, placement: result.placement });
  }

  /* Shopify's bot protection (hCaptcha, from content_for_header). Bound to a form, its
     provider takes over the form's submit: it gets a token, puts it in the form
     (h-captcha-response) and then calls the form's submit() as it was before it took
     over. So each Coven form's submit() is this script's post (installed before the
     provider binds), and Shopify.captcha.protect(form, callback) binds the form on demand:
     calling form.submit() in the callback runs the token step, then the post.
     A form marked data-noir-coven-native posts the normal way instead. */
  function captcha() {
    var c = window.Shopify && window.Shopify.captcha;
    return c && typeof c.protect === 'function' ? c : null;
  }

  function takeSubmit(form) {
    if (!form || form.__noirCovenSubmit) return;
    form.__noirCovenSubmit = true;
    try {
      form.submit = function () {
        var root = rootOfForm(form);
        if (!canFetch || !root || form.hasAttribute('data-noir-coven-native')) {
          nativeSubmit.call(form);
          return;
        }
        post(form, root);
      };
    } catch (e) {}
  }

  /* The normal post, for a bot challenge or an answer this script cannot read: a reload,
     with the result routed below. The submit event runs Shopify's own captcha step. */
  function submitNormally(form, root) {
    remember(idOf(root) || form.id);
    form.setAttribute('data-noir-coven-native', '');
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  /* The sent form's state in the page Shopify answered with. */
  function readAnswer(html, url, id) {
    var doc = null;
    try {
      doc = new DOMParser().parseFromString(html, 'text/html');
    } catch (e) {}
    var form = doc && id ? doc.getElementById(id) : null;
    var root = rootOfForm(form);
    if (root) {
      var state = stateOf(root);
      if (state === 'success') return { state: 'success' };
      if (state === 'error') {
        var error = root.querySelector('[data-noir-coven-error]');
        return { state: 'error', message: error ? error.textContent.replace(/\s+/g, ' ').trim() : '' };
      }
    }
    if (/[?&]customer_posted=true(&|#|$)/.test(url || '')) return { state: 'success' };
    return { state: null };
  }

  /* One POST with the form's own fields (and the captcha token once it is in the form). */
  function post(form, root) {
    if (root.__noirAttempt) root.__noirAttempt.posted = true;
    var id = idOf(root) || form.id;
    var failed = root.getAttribute('data-noir-coven-failed') || 'Something went wrong. Please try again.';
    var action = (form.getAttribute('action') || '/contact').split('#')[0];
    setSending(root, true);
    window
      .fetch(action, {
        method: 'POST',
        /* Encoded as the browser posts this form. */
        body: new URLSearchParams(new FormData(form)),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
      .then(function (response) {
        if (/\/challenge(\/|\?|#|$)/.test(response.url || '')) return { challenge: true };
        return response.text().then(function (html) {
          return readAnswer(html, response.url, id);
        });
      })
      .then(function (answer) {
        if (answer.challenge || !answer.state) {
          submitNormally(form, root);
          return;
        }
        setSending(root, false);
        if (answer.state === 'success') joinedHere(root);
        else showError(root, answer.message || failed);
      })
      .catch(function () {
        setSending(root, false);
        showError(root, failed);
      });
  }

  function send(form, root) {
    if (root.classList.contains('is-sending')) return;
    var input = root.querySelector('input[type="email"]');
    if (input) {
      input.value = input.value.trim();
      if (!input.checkValidity()) {
        showError(root, root.getAttribute('data-noir-coven-invalid') || 'Enter a valid email address.');
        return;
      }
    }
    clearError(root);
    setSending(root, true);
    takeSubmit(form);
    /* If the captcha step never gets to the post (its script failed), give the form back. */
    var attempt = (root.__noirAttempt = { posted: false });
    window.setTimeout(function () {
      if (root.__noirAttempt !== attempt || attempt.posted) return;
      setSending(root, false);
      showError(root, root.getAttribute('data-noir-coven-failed') || 'Something went wrong. Please try again.');
    }, 45000);
    var c = captcha();
    if (c) {
      c.protect(form, function () {
        form.submit();
      });
    } else {
      post(form, root);
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var root = rootOfForm(form);
    if (!root || e.defaultPrevented) return;
    var id = idOf(root) || form.id;
    if (!id) return;
    if (!canFetch || form.hasAttribute('data-noir-coven-native')) {
      remember(id);
      return;
    }
    /* Ours alone: the captcha provider's own submit listener would post the form too. */
    e.preventDefault();
    e.stopPropagation();
    send(form, root);
  }, true);

  /* Every Coven form: inline messages instead of the browser's bubble, and submit() as
     this script's post, before the captcha provider binds (on focus). */
  function prepare(scope) {
    if (!canFetch) return;
    var roots = (scope || document).querySelectorAll('[data-noir-coven]');
    for (var i = 0; i < roots.length; i++) {
      var form = roots[i].closest('form');
      if (!form) continue;
      form.noValidate = true;
      takeSubmit(form);
    }
  }
  document.addEventListener('shopify:section:load', function (e) {
    prepare(e.target);
  });
  prepare(document);

  /* ---------- Pick the form that was sent ---------- */
  function pick(printed) {
    var hash = currentHash();
    var stored = storedId();

    function byId(id) {
      if (!id) return null;
      for (var i = 0; i < printed.length; i++) {
        if (idOf(printed[i]) === id) return printed[i];
      }
      return null;
    }

    var match = byId(hash) || byId(stored);
    if (match) return match;

    /* A post from a form that is not a Coven form (the contact letter, or any other
       form the hash names): none of ours was sent, so no form shows the code. */
    if (/(^|&)contact_posted=/.test((window.location.search || '').replace(/^\?/, ''))) return null;
    if (hash) {
      var named = document.getElementById(hash);
      if (named && named.tagName === 'FORM' && !rootOfForm(named)) return null;
    }

    for (var i = 0; i < printed.length; i++) {
      if (placementOf(printed[i]) !== 'popup') return printed[i];
    }
    return printed[0] || null;
  }

  /* ---------- Show the result ---------- */
  function headerOffset() {
    var header = document.querySelector('.shopify-section-header-sticky');
    if (!header) return 0;
    var r = header.getBoundingClientRect();
    return r.bottom > 0 ? Math.min(r.height, 160) : 0;
  }

  function reveal(root) {
    if (!document.contains(root)) return;
    var error = stateOf(root) === 'error';
    var box = error ? root : root.querySelector('[data-noir-coven-success]') || root;
    var focusTarget = error
      ? root.querySelector('input[type="email"]')
      : root.querySelector('[data-noir-coven-focus]');
    var view = window.innerHeight || document.documentElement.clientHeight;
    var top = headerOffset() + 12;
    var r = box.getBoundingClientRect();
    if (r.height && (r.top < top || r.bottom > view - 12)) {
      var y = window.pageYOffset + r.top - top;
      var room = view - top - r.height;
      if (room > 24) y -= room / 2;
      window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: reduceMotion() ? 'auto' : 'smooth' });
    }
    focusEl(focusTarget);
  }

  /* Wait for images and fonts so the scroll lands where the form ends up. */
  function afterLoad(fn) {
    function run() {
      window.requestAnimationFrame(fn);
    }
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  /* ---------- Route ---------- */
  var result = { id: null, state: null, placement: null };
  var routed = false;

  function finish() {
    routed = true;
    emit(document, 'noir:coven:ready', { id: result.id, state: result.state, placement: result.placement });
  }

  function route() {
    prepare(document);
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-noir-coven]'));
    var printed = roots.filter(function (r) {
      var s = stateOf(r);
      return s === 'success' || s === 'error';
    });
    var posted = /(^|&)customer_posted=true(&|$)/.test((window.location.search || '').replace(/^\?/, ''));

    if (!printed.length) {
      /* Keep a stored id while the post is still in flight (a challenge page has no form). */
      if (posted) clearStored();
      finish();
      return;
    }

    var target = pick(printed);
    printed.forEach(function (r) {
      if (r !== target) revert(r);
    });
    clearStored();

    if (target) {
      result = { id: idOf(target), state: stateOf(target), placement: placementOf(target) || null };
      if (result.state === 'success') {
        write(JOINED, '1');
        emit(target, 'noir:coven:joined', { id: result.id, placement: result.placement });
      }
      if (result.placement !== 'popup') {
        afterLoad(function () {
          reveal(target);
        });
      }
    }
    finish();
  }

  Noir.coven = {
    __ready: true,
    joined: function () {
      return read(JOINED) === '1';
    },
    sentId: function () {
      return result.id || storedId();
    },
    state: function () {
      return result.state;
    },
    placement: function () {
      return result.placement;
    },
    ready: function () {
      return routed;
    }
  };

  /* Deferred scripts run once the DOM is parsed; route now so later scripts can read the
     result. A late insert before DOMContentLoaded waits for it. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', route, { once: true });
  } else {
    route();
  }
})();
